module.exports = "<div></div>";


//////////////////
// WEBPACK FOOTER
// ./src/component/logout/Logout.html
// module id = 171
// module chunks = 0